// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__18Ojy","badges":"styles_badges__2dAzC"};